import React from 'react'
import classNames from 'classnames'

import { CustomNoteIcon } from './CustomNoteIcon/CustomNoteIcon'
import { ICONS_COLORS } from './EmojiPicker/constants'

export const IconInColorBox = ({
  iconShape,
  iconColor,
  size,
  className,
}: {
  iconShape: string
  iconColor?: string
  size: number
  className?: string
}) => {
  let iconBackgroundColor = ICONS_COLORS.find((c) => c.id === iconColor)?.light
  if (!iconBackgroundColor && ICONS_COLORS.length > 0 && ICONS_COLORS[0]) {
    iconBackgroundColor = ICONS_COLORS[0].light
  }

  const paddingSize = size / 4
  const radiusSize = size / 3
  const iconSize = size - 2 * paddingSize
  return (
    <div
      className={classNames(
        'flexbox flexbox-centered position-relative ',
        className
      )}
      style={{ height: size, width: size }}
    >
      <div
        className="position-coverer "
        style={{
          backgroundColor: iconBackgroundColor,
          opacity: iconBackgroundColor ? 0.1 : 1,
          borderRadius: radiusSize,
        }}
      />
      <CustomNoteIcon
        iconShape={iconShape}
        iconColor={iconColor}
        size={iconSize}
      />
    </div>
  )
}
